export const useStoreDancers = defineStore('StoreDancers', {
    state: () => ({
        dancers: null,
        error: null,
        filter: {
            paginate: {
                auto: false,
            },
        },
    }),
    actions: {
        async initDancers() {
            if (this.dancers) return Promise.resolve(this.dancers);
            return this.getDancers();
        },
        async getDancers() {
            this.error = null;
            ({dancers: this.dancers, error: this.error} = await useQueryDancers().get(this.filter));
        },
    },
    getters: {
        filterDancers() {
            return ({minVideos, limitTo, orderByName}) => {
                let dancers = [];
                if (!this.dancers) return dancers;
                dancers = this.dancers.filter(
                    (dancer) => dancer.dancer_videos && (minVideos === undefined || dancer.dancer_videos >= minVideos),
                );
                dancers = orderByName ? dancers.sort((a, b) => (a.dancer_name > b.dancer_name ? 1 : -1)) : dancers;
                dancers = limitTo ? dancers.slice(0, limitTo) : dancers;
                return dancers;
            };
        },
        searchDancers() {
            return ({dancerName}) => {
                if (!this.dancers) return [];
                return this.dancers.filter(
                    (dancer) =>
                        dancer.dancer_videos && dancer.dancer_name.toLowerCase().includes(dancerName.toLowerCase()),
                );
            };
        },
    },
});
